import styles from "./Cree.module.css";

export default function Cree() {
  return (
    <div className={styles.container}>
      <div className={styles.mimo}>
        <div>
          <div>Cree</div>
          <div>COO, Project Manager</div>
        </div>
      </div>
      <div className={styles.textBox}>
        <div className={styles.textList}>
          <div>
            먼데이오프는 직급에 상관없이 좋은 방향을 제시하고, 자유롭게 소통할
            수 있는 문화를 지향해요.
          </div>
          <br />
          <div>
            우리의 제 1의 목표는 회사의 성장이지만, 제 2의 목표는 다른 어느 것도
            아닌 개인의 성장이에요. 구성원의 성장은 먼데이오프가 지원할게요.
          </div>
          <br />
          <div>회사와 함께 성장하는 기분을 맘껏 느껴보세요.</div>
          <br />
        </div>
        <div>Cree/ COO, Project Manager</div>
      </div>
    </div>
  );
}
